module.exports = __webpack_public_path__ + "img/userpic.eb0bb1b8.png";